var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Navigation'),_c('v-main',[_c('v-container',{staticClass:"page-container",attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }